export const menuList = [
  {
    id: 1,
    path: "/index",
    name: "首页",
  },
  {
    id: 2,
    path: "/qualification",
    name: "资质展示",
  },
  {
    id: 3,
    path: "/engineDownload",
    name: "引擎下载",
  },
  {
    id: 12,
    path: "",
    name: "开发文档",
  },
  {
    id: 11,
    path: "/news",
    name: "新闻资讯",
  },
  {
    id: 4,
    path: "/updateLog",
    name: "更新日志",
  },
  {
    id: 5,
    path: "/legendBox",
    name: "996传奇盒子",
  },
  {
    id: 6,
    path: "/legendForum",
    name: "传奇论坛",
  },
  {
    id: 7,
    path: "/legendWorldForum",
    name: "传世论坛",
  },
  {
    id: 8,
    path: "/joinUs",
    name: "加入我们",
  },
  {
    id: 9,
    path: "/collaborate",
    name: "传奇/传世合作",
  },
  //   {
  //     id: 10,
  //     path: "/register",
  //     name: "注册",
  //   },
];

export const pathList = [
  {
    id: 1,
    path: "/index",
    name: "首页",
  },
  {
    id: 2,
    path: "/qualification",
    name: "资质展示",
  },
  {
    id: 3,
    path: "/engineDownload",
    name: "引擎下载",
  },
  {
    id: 11,
    path: "/news",
    name: "新闻资讯",
  },
  {
    id: 4,
    path: "/updateLog",
    name: "更新日志",
  },
  {
    id: 5,
    path: "/legendBox",
    name: "996传奇盒子",
  },
  {
    id: 6,
    path: "/legendForum",
    name: "传奇论坛",
  },
  {
    id: 7,
    path: "/legendWorldForum",
    name: "传世论坛",
  },
  {
    id: 8,
    path: "/joinUs",
    name: "加入我们",
  },
  {
    id: 9,
    path: "/collaborate",
    name: "传奇/传世合作",
  },
  {
    id: 10,
    path: "/gameDetail",
    name: "游戏详情",
  },
  {
    id: 1,
    path: "/",
    name: "首页",
  },
  {
    id: 11,
    path: "/user",
    name: "隐私政策",
  },
  {
    id: 12,
    path: "/userPlan",
    name: "计划",
  },
  {
    id: 20,
    path: "/contactExample",
    name: "全部案例",
  },
];

export const bgList = [
  {
    id: 2,
    path: "/qualification",
    name: "资质展示",
  },
  {
    id: 11,
    path: "/news",
    name: "新闻资讯",
  },
  {
    id: 16,
    path: "/news/detail",
    name: "新闻资讯",
  },
  {
    id: 20,
    path: "/contactExample",
    name: "全部案例",
  },
  //   {
  //     id: 3,
  //     path: "/engineDownload",
  //     name: "引擎下载",
  //   },
  {
    id: 4,
    path: "/updateLog",
    name: "更新日志",
  },
  {
    id: 10,
    path: "/gameDetail",
    name: "游戏详情",
  },
  {
    id: 11,
    path: "/user",
    name: "隐私政策",
  },
  {
    id: 12,
    path: "/userPlan",
    name: "计划",
  },
  {
    id: 13,
    path: "/contactUs",
    name: "联系我们",
  },
  {
    id: 14,
    path: "/introduces",
    name: "公司简介",
  },
  {
    id: 15,
    path: "/childrenPlan",
    name: "儿童隐私保护指引",
  },
];
